<script setup>
import { useGlobalLoading } from '@/stores/loading.js'

const { isLoading } = useGlobalLoading()
</script>

<template>
  <!-- <div v-if="isLoading" class="loading-overlay">
    <img src="@/assets/logo-dhara.avif" alt="Loading..." class="logo-colorize" />
  </div> -->

  <div v-if="isLoading" class="loading-overlay">
    <div class="spinner-border text-primary" role="status">
      <span class="visually-hidden">Cargando...</span>
    </div>
  </div>
</template>

<style scoped>
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(1px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.logo-colorize {
  width: 100px;
  /* Ajusta al tamaño que prefieras */
  filter: grayscale(100%);
  animation: colorize 3s ease-in-out infinite alternate;
}

@keyframes colorize {
  0% {
    filter: grayscale(100%);
  }

  100% {
    filter: grayscale(0%);
  }
}
</style>
